import {
  reactQueryGet,
  reactQueryPost,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface ShowParams {
  id: number;
  isForAdminReview?: boolean;
  quizId: number;
}
const show = ({ quizId, id, isForAdminReview = false }: ShowParams) =>
  reactQueryGet(
    internalApi.quizAttempts.show({
      quizId,
      id,
      params: { for_admin_review: isForAdminReview },
    }),
  );

export interface CreateAttemptPayload {
  responses: {
    quizzes_question_id: number;
    selected_options: {
      quizzes_option_id: number;
    }[];
  }[];
}

export interface CreateAttemptFormattedPayload {
  responses_attributes: {
    quizzes_question_id: number;
    selected_options_attributes: {
      quizzes_option_id: number;
    }[];
  }[];
}

interface CreateParams {
  payload: CreateAttemptFormattedPayload;
  quizId: number;
}

export interface UpdateAttemptPayload {
  result: "passed" | "failed" | "pending";
}

interface UpdateParams {
  id: number;
  payload: UpdateAttemptPayload;
  quizId: number;
}
const create = ({ quizId, payload }: CreateParams) =>
  reactQueryPost(internalApi.quizAttempts.create({ quizId }), payload);

const update = ({ quizId, id, payload }: UpdateParams) =>
  reactQueryPut(internalApi.quizAttempts.update({ quizId, id }), payload);

export const quizAttemptsApi = {
  show,
  create,
  update,
};
